module.exports = __webpack_public_path__ + "img/centerI.244a8876.png";